// biome-ignore lint/style/useImportType: legacy import, will be migrated
import * as React from 'react';

import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import CrehanaLogo from '@crehana/icons/logos/CrehanaLogo';
import { black, primaryMain, white } from '@crehana/ui/dist/styles/colors';

interface LogoProps {
  darkMode?: boolean;
  size?: number;
}

const Logo: React.FC<React.PropsWithChildren<LogoProps>> = ({
  darkMode = false,
  size = 26,
}) => (
  <a href={CREHANA_BASE_URL_PRD} aria-label="Crehana for Business">
    <CrehanaLogo
      className="cursor-pointer"
      color={darkMode ? white : primaryMain}
      secondaryColor={darkMode ? white : black}
      size={size}
    />
  </a>
);

export default Logo;
